import React from 'react';

import { IconButton, SvgIcon, SxProps, Theme } from '@mui/material';
import Button, { ButtonProps } from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { CloseIcon } from '@/utils/iconSVG';

const iconButtonStyles: SxProps<Theme> = {
  position: 'absolute',
  right: 8,
  top: 8,
  color: (theme) => theme.palette.grey[500],
};

type AlertDialogProps = {
  title: React.ReactNode;
  open?: boolean;
  agreeMessage: string;
  disagreeMessage: string;
  content: React.ReactNode;
  agreeButtonColor: ButtonProps['color'];
  onAgree?: () => void;
  onDisagree?: () => void;
};
export const AlertDialog: React.FunctionComponent<AlertDialogProps> = ({
  open,
  title,
  content,
  agreeMessage,
  disagreeMessage,
  agreeButtonColor,
  onDisagree,
  onAgree,
}) => {
  const handleClose = () => {
    onDisagree();
  };

  if (!open) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
      <IconButton aria-label='close' onClick={handleClose} sx={iconButtonStyles}>
        <SvgIcon component={CloseIcon} />
      </IconButton>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>{content}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ gap: 2 }}>
        <Button color='alternative' onClick={handleClose}>
          {disagreeMessage}
        </Button>
        <Button variant='contained' color={agreeButtonColor} onClick={onAgree} autoFocus>
          {agreeMessage}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
